export const conexesTokenDurationInMinutes = 24 * 60; // 1 day
export const conexesTokenRefreshThresholdInMinutes = 5;
export function getHighestPriorityLink(externalLinks) {
    const candidateLinks = (externalLinks ?? []).filter((externalPatientLink) => externalPatientLink.externalPatientIdType === "nhs.number");
    // The lowest number is the highest priority (i.e. 1 is higher priority than 2)
    return candidateLinks.sort((a, b) => a.priorityWithinExternalSystem - b.priorityWithinExternalSystem)?.[0];
}
export function getExternalPatientIdValue(externalLinks) {
    const highestProirityLink = getHighestPriorityLink(externalLinks);
    if (!highestProirityLink)
        return null;
    return highestProirityLink?.externalPatientIdValue[0] ?? null;
}
//# sourceMappingURL=rio.js.map